import React from 'react'
import { useTranslation } from 'react-i18next'

import { Grid, Typography, IconButton, Box } from '@material-ui/core'
// import { Skeleton } from '@material-ui/lab'

import { MdModeEditOutline } from 'react-icons/md'

import ManageRatingCriteria from './ManageRatingCriteria'
import DeleteRatingCriteriaAlert from './DeleteRatingCriteriaAlert'
import Button from '../competition-info/submission/components/Button'
import { icons } from './RatingCriteriaIconOptions'
import useRatingCriteria from '../hooks/useRatingCriteria'

export default function RatingCriteria({ collectionName }) {
  return (
    <div>
      <Headers />
      <Body collectionName={collectionName} />
    </div>
  )
}

function Headers() {
  const { t } = useTranslation('proposals')
  return (
    <Grid container alignItems="center" className="py-1 border-bottom">
      <Grid item xs={2} className="sm">
        <Typography>{t('Icon')}</Typography>
      </Grid>
      <Grid item xs={5} className="sm">
        <Typography>{t('Criteria')}</Typography>
      </Grid>
      <Grid item xs={2} className="sm">
        <Typography align="center">{t('Multiplier')}</Typography>
      </Grid>
      <Grid item xs={2} className="sm">
        <Typography align="center">{t('Position')}</Typography>
      </Grid>
      <Grid item xs={1} className="sm">
        <Typography align="center"></Typography>
      </Grid>
    </Grid>
  )
}

function Body({ collectionName }) {
  const { ratingCriteria } = useRatingCriteria(collectionName)
  const { t } = useTranslation('proposals')

  if (!ratingCriteria || ratingCriteria.length === 0) {
    return (
      <div>
        {/* <Skeleton variant="rect" height={500} /> */}
        <ManageRatingCriteria collectionName={collectionName}>
          <Box textAlign="center" style={{ marginTop: 56 }}>
            <Button type="button" variant="primary">
              <strong>{t('Add criteria')}</strong>
            </Button>
          </Box>
        </ManageRatingCriteria>
      </div>
    )
  }

  return (
    <>
      <Grid container alignItems="center">
        {ratingCriteria.map(item => (
          <Item key={item.id} {...item}>
            <Box display="flex" alignItems="enter" style={{ gap: 16 }}>
              <ManageRatingCriteria
                criteriaItem={item}
                collectionName={collectionName}
              >
                <IconButton className="mr-1" size="small" aria-label="Edit">
                  <MdModeEditOutline style={{ width: 18, height: 18 }} />
                </IconButton>
              </ManageRatingCriteria>
              <DeleteRatingCriteriaAlert
                collectionName={collectionName}
                criteriaItem={item}
              />
            </Box>
          </Item>
        ))}
      </Grid>
      <ManageRatingCriteria collectionName={collectionName}>
        <Box textAlign="center" style={{ marginTop: 56 }}>
          <Button type="button" variant="primary">
            <strong>{t('Add criteria')}</strong>
          </Button>
        </Box>
      </ManageRatingCriteria>
    </>
  )
}

function Item({ iconName, label, multiplier, position, children }) {
  const { t } = useTranslation('proposals')
  const Icon = icons[iconName]
  const iconProps = { style: { width: 23, height: 23 } }

  return (
    <>
      <Grid item xs={2} className="py-2 sm">
        {Icon && <Icon {...iconProps} />}
      </Grid>
      <Grid item xs={5} className="py-2 sm">
        <Typography>{t(label)}</Typography>
      </Grid>
      <Grid item xs={2} className="py-2 sm">
        <Typography align="center">
          {parseFloat(multiplier).toFixed(2)}
        </Typography>
      </Grid>
      <Grid item xs={2} className="py-2 sm">
        <Typography align="center">{position}</Typography>
      </Grid>
      <Grid item xs={1} className="py-2 sm">
        {children}
      </Grid>
    </>
  )
}
